module.exports = __webpack_public_path__ + "static/img/200136.a3cbf107.png";